/**
 * CommissionTable Component
 * 수수료 테이블 컴포넌트
 */
import React from 'react';
import Pagination from '@/shared/components/dataDisplay/Pagination';
import { SupplierCommissionRow, PeriodType } from '../types/feeManagement.types';
import { TABLE_COLUMN_COUNT, ITEMS_PER_PAGE } from '../utils/feeManagementHelpers';
import CommissionTableRow from './CommissionTableRow';

interface CommissionTableProps {
    currentItems: SupplierCommissionRow[];
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    onNewCommissionTypeChange: (supplierId: string, period: PeriodType, value: string) => void;
    onNewAmountChange: (supplierId: string, period: PeriodType, value: string) => void;
    onNewPaybackUseYnChange: (supplierId: string, value: string) => void;
    onNewPaybackAmountChange: (supplierId: string, value: string) => void;
    onNewStartDateChange: (supplierId: string, value: string) => void;
    onShowHistory: (supplierId: string, supplierName: string) => void;
    onSave: (supplierId: string) => void;
    onToggleFeeChange: (supplierId: string) => void;
}

const CommissionTable: React.FC<CommissionTableProps> = ({
                                                             currentItems,
                                                             currentPage,
                                                             totalPages,
                                                             onPageChange,
                                                             onNewCommissionTypeChange,
                                                             onNewAmountChange,
                                                             onNewPaybackUseYnChange,
                                                             onNewPaybackAmountChange,
                                                             onNewStartDateChange,
                                                             onShowHistory,
                                                             onSave,
                                                             onToggleFeeChange
                                                         }) => {
    const getTableIndex = (index: number): number => {
        return (currentPage - 1) * ITEMS_PER_PAGE + index + 1;
    };

    return (
        <>
            <div className="table-container" style={{ overflowX: 'auto' }}>
                <table
                    className="supplier-selection-table"
                    style={{ width: '100%', minWidth: '900px', tableLayout: 'fixed' }}
                >
                    <colgroup>
                        <col style={{ width: '50px' }} />
                        <col style={{ width: '170px' }} />
                        <col style={{ width: '155px' }} />
                        <col style={{ width: '155px' }} />
                        <col style={{ width: '140px' }} />
                        <col style={{ width: '110px' }} />
                        <col style={{ width: '160px' }} />
                    </colgroup>
                    <thead>
                    <tr>
                        <th>NO</th>
                        <th>협력사명</th>
                        <th>선정산</th>
                        <th>주정산</th>
                        <th>페이백(건당)</th>
                        <th>적용일</th>
                        <th>관리</th>
                    </tr>
                    </thead>
                    <tbody>
                    {currentItems.length === 0 ? (
                        <tr>
                            <td colSpan={TABLE_COLUMN_COUNT} className="text-center text-gray-600">
                                조회된 협력사가 없습니다.
                            </td>
                        </tr>
                    ) : (
                        currentItems.map((row, index) => (
                            <CommissionTableRow
                                key={row.supplierId}
                                row={row}
                                index={getTableIndex(index)}
                                onNewCommissionTypeChange={onNewCommissionTypeChange}
                                onNewAmountChange={onNewAmountChange}
                                onNewPaybackUseYnChange={onNewPaybackUseYnChange}
                                onNewPaybackAmountChange={onNewPaybackAmountChange}
                                onNewStartDateChange={onNewStartDateChange}
                                onShowHistory={onShowHistory}
                                onSave={onSave}
                                onToggleFeeChange={onToggleFeeChange}
                            />
                        ))
                    )}
                    </tbody>
                </table>
            </div>

            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
            />
        </>
    );
};

export default CommissionTable;
